import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import News from "@/entity/Settings/news";
import { INews, INewsListItem, NewsResponseType } from '@/entity/Settings/news.types';
import { INewsRepository } from "./NewsRepository.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";
import { SiteNewsRequestType } from "@/form/Settings/site/news.types";

export class NewsRepository implements INewsRepository {
    async fetchAll(data?: FormData): Promise<INews> {
        const response = await Api.get('/settings/news/get', { 
            params: data, 
            paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
            }});
        const responseData = response.data as NewsResponseType;
        return new News(responseData);
    }

    async fetchData(data: PaginationRequestType): Promise<INewsListItem> {

        const response = await Api.get(`/settings/news/get`, {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});

        const responseData = response.data as NewsResponseType;

        return new News(responseData).data[0];
    }

    async create(data: SiteNewsRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/settings/news/create', data);
        return response.data;
    }

    async update(data: SiteNewsRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/settings/news/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/settings/news/delete`, data);
        const responseData = response.data;
        return responseData;
    }

}